var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-form-group', {
    attrs: {
      "label": "Province",
      "label-for": "Provinsi"
    }
  }, [_c('v-select', {
    staticClass: "style-chooser",
    attrs: {
      "id": "provinsi",
      "label": "name",
      "options": _vm.option.provience,
      "reduce": function reduce(option) {
        return option.name;
      },
      "placeholder": "Pilih Provinsi",
      "clearable": false,
      "disabled": _vm.checked
    },
    on: {
      "input": function input(e) {
        return _vm.onSelect(e, 'provinsi');
      }
    },
    model: {
      value: _vm.form.provinsi,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "provinsi", $$v);
      },
      expression: "form.provinsi"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "City",
      "label-for": "Kota"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "Kota",
      "label": "name",
      "options": _vm.option.cities,
      "reduce": function reduce(option) {
        return option.name;
      },
      "placeholder": _vm.form.kecamatan ? 'Pilih Kabupaten' : 'Pilih Provinsi Terlebih Dahulu',
      "clearable": false,
      "disabled": _vm.checked || this.loadingKota || !_vm.form.provinsi
    },
    on: {
      "input": function input(e) {
        return _vm.onSelect(e, 'kabupaten');
      }
    },
    model: {
      value: _vm.form.kabupaten,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "kabupaten", $$v);
      },
      expression: "form.kabupaten"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Dictrict",
      "label-for": "Kecamatan"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "Kecamatan",
      "label": "name",
      "options": _vm.option.districts,
      "reduce": function reduce(option) {
        return option.name;
      },
      "placeholder": _vm.form.kabupaten ? 'Pilih Kecamatan' : 'Pilih Kabupaten Terlebih Dahulu',
      "clearable": false,
      "disabled": _vm.checked || this.loadingKecamatan || !_vm.form.kabupaten
    },
    on: {
      "input": function input(e) {
        return _vm.onSelect(e, 'kecamatan');
      }
    },
    model: {
      value: _vm.form.kecamatan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "kecamatan", $$v);
      },
      expression: "form.kecamatan"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Village",
      "label-for": "Kelurahan"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "Kecamatan",
      "label": "name",
      "options": _vm.option.districts,
      "reduce": function reduce(option) {
        return option.name;
      },
      "placeholder": _vm.form.kecamatan ? 'Pilih Kelurahan' : 'Pilih Kecamatan Terlebih Dahulu',
      "clearable": false,
      "disabled": _vm.checked || this.loadingKelurahan || !_vm.form.kecamatan
    },
    model: {
      value: _vm.form.kelurahan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "kelurahan", $$v);
      },
      expression: "form.kelurahan"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Postal Code",
      "label-for": "kode_pos"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "height": "35px"
    },
    attrs: {
      "id": "kode_pos",
      "type": "number",
      "name": "kode_pos",
      "disabled": _vm.checked
    },
    on: {
      "keydown": _vm.checkKeyNumber
    },
    model: {
      value: _vm.form.kode_pos,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "kode_pos", $$v);
      },
      expression: "form.kode_pos"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Address",
      "label-for": "alamat_domisili"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "alamat_domisili",
      "name": "alamat_domisili",
      "rows": "1",
      "disabled": _vm.checked,
      "placeholder": "Alamat..."
    },
    model: {
      value: _vm.form.alamat,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "alamat", $$v);
      },
      expression: "form.alamat"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }